// Existing forms retain their mapper behavior. The register assistant opts into
// a field patch so editing an email cannot reconstruct CRM or accounting metadata.
const registryRecordPatchApi = (() => {
  const party = { name: ['name'], org: ['organizationNumber'], email: ['email'], phone: ['phone'], addr: ['address'], zip: ['postalCode'], city: ['postalPlace'] }
  const mappings: Record<string, Record<string, string[]>> = {
    customer: { ...party, note: ['note'], defaultCustomerReference: ['defaultCustomerReference'], followUp: ['nextFollowUpDate'], contactPersons: ['contactPersons'] },
    supplier: { ...party, defaultDueDays: ['defaultDueDays'], defaultCostAccountCode: ['defaultCostAccountCode'], defaultSettlementAccountCode: ['defaultSettlementAccountCode'] },
    product: { name: ['name'], desc: ['description'], price: ['unitPrice'], sku: ['sku'], ean: ['ean', 'gtin'], productGroup: ['productGroup'], type: ['kind'], vatSelection: ['vatRate', 'vatTreatment', 'salesVatCode'] },
  }
  const apply = (kind: string, mapped: any, existing: any, ui: any, fields?: string[]) => {
    if (!fields || !existing?.id) return mapped
    const mapping = mappings[kind]
    if (!mapping || !Array.isArray(fields) || fields.some(key => !Object.hasOwn(mapping, key))) throw new Error('registry.unsupportedField')
    const next = { ...existing }
    for (const field of fields) for (const key of mapping[field]) {
      // The legacy mapper treats empty strings as fallback-to-existing. An
      // explicit field patch can clear an optional text field instead.
      const value = field === 'contactPersons' ? ui.contactPersons : ui[field] === '' && !['name', 'price', 'defaultDueDays', 'type', 'vatSelection'].includes(field) ? '' : mapped[key]
      if (value === undefined) delete next[key]
      else next[key] = value
    }
    return next
  }
  const organizationKey = (value: unknown) => {
    const compact = String(value ?? '').toUpperCase().replace(/[\s.\-]/g, '')
    return /^(?:NO)?\d{9}(?:MVA)?$/.test(compact) ? compact.replace(/^NO/, '').replace(/MVA$/, '') : compact
  }
  const archived = (row: any) => row?.arkivert === true || ['archived', 'passiv'].includes(row?.status)
  const findOrganizationConflict = (records: any[], next: any, existing?: any) => {
    const org = organizationKey(next.organizationNumber)
    if (!org) return null
    const country = String(next.country || '').toUpperCase()
    // Existing duplicates must still be editable for cleanup. Reopening one
    // or changing its identity must go through the duplicate check.
    if (existing && organizationKey(existing.organizationNumber) === org &&
      String(existing.country || '').toUpperCase() === country && !(archived(existing) && !archived(next))) return null
    return records.find(row => row.id !== next.id && organizationKey(row.organizationNumber) === org &&
      !(country && row.country && String(row.country).toUpperCase() !== country)) || null
  }
  return { apply, findOrganizationConflict }
})()
Object.assign(globalThis, { PlummeRegistryRecordPatch: registryRecordPatchApi })
